// following cimbidum strings
// ref: https://gitlab.cloud.bukalapak.io/bukalapak/cymbidium/-/commit/4ff91ec4477763b266a3bade289da02625ac8712
export const PAYMENT_METHOD_TYPE_UNSPECIFIED = 'unspecified';
export const PAYMENT_METHOD_TYPE_WALLET = 'wallet';
export const PAYMENT_METHOD_TYPE_VJI_WALLET = 'vji-wallet';

export const PAYMENT_METHOD_NAME = {
  [PAYMENT_METHOD_TYPE_WALLET]: 'Saldo Mitra',
  [PAYMENT_METHOD_TYPE_VJI_WALLET]: 'BukaPay',
};

export const BALANCE_STATE_ACTIVE = 'active';
export const BALANCE_STATE_INACTIVE = 'inactive';
export const BALANCE_STATE_FROZEN = 'frozen';
export const BALANCE_STATE_ERROR = 'error';


// value follow the apps config 'mitra-payment-method-config'
// ref: https://gitlab.cloud.bukalapak.io/apps/mitra_bukalapak_android/-/merge_requests/236
export const NEO_CONFIG_PAYMENT_CODE_MAPPING = {
  wallet: PAYMENT_METHOD_TYPE_WALLET,
  vji_wallet: PAYMENT_METHOD_TYPE_VJI_WALLET,
};
